import React from 'react';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import { FaChevronRight } from 'react-icons/fa';
import { getHistoryReports } from 'lib/api';
import {
  LoadingIndicator,
  Table,
  TableContextProvider,
  TableFooter,
  TablePaginationNew,
  TablePaginationSizeNew,
} from 'lib/components';
import { Heading } from 'lib/components/styles/typography';
import { STANDARD_DATE_FORMAT } from 'lib/const/DateFormat';

const TableCell = styled.div<{ clicked?: boolean }>`
  /*** SUS-926 changes ***/
  padding-left: 24px;
  cursor: ${props =>
    !!props.clicked ? 'pointer' : 'auto'}; /*** SUS-926 changes ***/
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  text-transform: capitalize;
`;

const tableFields = {
  report: 'Name',
  dateSent: 'Sent Date',
  recurring: 'Recurring',
};

const fields = ['report', 'dateSent'];

export const List = () => {
  const [reports, setReports] = React.useState([]);
  const [count, setCount] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [size, setSize] = React.useState(10);
  const [loading, setLoading] = React.useState(false);

  const history = useHistory();

  const fetchHistory = async (page: number, size: number) => {
    setLoading(true);
    const { count, reportHistories } = await getHistoryReports({ page, size });
    setLoading(false);
    setCount(count);
    setReports(reportHistories);
  };

  React.useEffect(() => {
    fetchHistory(0, 10);
  }, []);

  const onHistoryPaginationChange = async ({
    page: newPage,
    size: newSize,
  }: any) => {
    if (page !== newPage || size !== newSize) {
      setPage(newPage);
      setSize(newSize);
      await fetchHistory(newPage, newSize);
    }
  };

  const rows = reports.map((report: any, index: number) => ({
    key: index,
    columns: [
      ...fields.map(field => {
        let value = report[field];

        if (field === 'dateSent') {
          value = dayjs(report[field]).format(STANDARD_DATE_FORMAT);
        }

        if (field === 'recurring') {
          value = report[field] ? 'Yes' : '-';
        }
        return (
          <TableCell clicked={true}>{value}</TableCell>
        ); /*** SUS-926 changes ***/
      }),
      <TableCell clicked={true} style={{ textAlign: 'right' }}>
        <FaChevronRight color='#9297a2' size={14} />
      </TableCell>,
    ],
    onClick: () => history.push(`/reports/history/${report.id}`),
  }));

  return (
    <>
      <Heading>Report History</Heading>
      {loading && <LoadingIndicator isLoading={loading} height='300px' />}
      {!loading && !!reports.length && (
        <>
          {!!reports.length && (
            <TableContextProvider
              total={count}
              initSize={size}
              initPage={page}
              onChange={onHistoryPaginationChange}
            >
              <div style={{ overflowX: 'auto' }}>
                <Table
                  compact={true}
                  headers={[
                    ...fields.map(field => {
                      // @ts-ignore
                      return <TableCell>{tableFields[field]}</TableCell>;
                    }),
                    '',
                  ]}
                  hoverable={false}
                  rows={rows}
                />
              </div>
              <TableFooter>
                <TablePaginationNew />
                <TablePaginationSizeNew globalName='history_reports_list' />
              </TableFooter>
            </TableContextProvider>
          )}
          {!reports.length && (
            <div style={{ textAlign: 'center' }}>No data to show.</div>
          )}
        </>
      )}
    </>
  );
};
